export default "<p>outsource-courses-list works!</p>\n"